module.exports = __webpack_public_path__ + "media/images/instagram-be813a0d6a85c2a449f516f608356931.svg";